import styled from '@emotion/styled';
import type { BoxProps, ButtonProps } from '@hover/blueprint';
import { Box, Heading, Icon } from '@hover/blueprint';
import type { IconProp } from '@hover/icons';
import React from 'react';

import { Button } from 'src/shared/components';

type PressType = ButtonProps['onClick'];

type CardHeaderProps = {
  leftIcon?: IconProp;
  leftActionHandler?: PressType;
  rightIcon?: IconProp;
  rightActionHandler?: PressType;
  headerText?: string | null;
} & BoxProps;

interface IconButtonProps extends Pick<ButtonProps, 'onClick'> {
  icon: IconProp;
}

const IconButton = ({ icon, onClick, ...props }: IconButtonProps) => (
  <Button
    fill="minimal"
    label="iconButton"
    onClick={onClick}
    shape="circle"
    {...props}
  >
    <Icon color="secondary600" icon={icon} size="medium" />
  </Button>
);

const CardHeaderText = styled(Heading)`
  font-weight: 700;
`;

const CardHeader = ({
  leftIcon,
  leftActionHandler,
  rightIcon,
  rightActionHandler,
  headerText,
  ...props
}: CardHeaderProps) => (
  <Box display="block" marginBottom={600} width="100%" {...props}>
    <Box alignItems="center" justifyContent="space-between">
      <Box alignItems="center" height="100%">
        {leftIcon && <IconButton icon={leftIcon} onClick={leftActionHandler} />}
        <CardHeaderText as="h1" marginBottom={0} marginLeft={200} size={500}>
          {headerText}
        </CardHeaderText>
      </Box>
      {rightIcon && (
        <IconButton
          data-testid="closeCardButton"
          icon={rightIcon}
          onClick={rightActionHandler}
        />
      )}
    </Box>
  </Box>
);

export { CardHeader };
